export default __webpack_public_path__ + "static/media/878.16c07adc.png";